<template>
  <div class="grid grid-cols-fit-250 items-end gap-2">
    <wd-filter-input
      v-for="filter in localFilters"
      @update-filter="updateFilterValue"
      :filter="filter"
      :key="filter.id"
    />
  </div>
</template>

<script>
const WdFilterInput = require("@/modules/core/components/WdFilterInput.vue")
  .default;

import { Filter } from "@/mixins/models/Filter";
import _ from "lodash";

export default {
  name: "WdFilter",
  data() {
    return {
      localFilters: [],
      filterTypes: {
        search: (Input, Key) => {
          if (!Input || !this.filterValues[Key]) return false;
          let regVar = new RegExp(this.filterValues[Key].toUpperCase(), "g");
          return Input.filter((e) => {
            return regVar.test(e[Key].toUpperCase());
          });
        },
        equal: (Input, Key) => {
          if (!Input || !this.filterValues[Key]) return false;
          return Input.filter((e) => e[Key] === this.filterValues[Key]);
        },
        includes: (Input, Key) => {
          if (!Input || !this.filterValues[Key]) return false;
          return Input.filter((e) =>
            e[Key].some((r) => r === this.filterValues[Key])
          );
        },
      },
      filterValues: {},
    };
  },
  props: {
    filters: {
      required: true,
    },
    inputArray: {
      required: true,
    },
  },
  components: {
    WdFilterInput,
  },
  methods: {
    updateFilterValue(Input) {
      this.filterValues[Input.key] = Input.value;
      this.filterEntries(this);
    },
    filterEntries: _.debounce((That) => {
      let filteredArray = That.inputArray;

      That.localFilters.forEach((e) => {
        if (e.value === null || e.value === "") {
          return filteredArray;
        }
        filteredArray =
          That.filterTypes[e.type](filteredArray, e.key) || filteredArray;
      });

      That.$emit("update", filteredArray);
    }, 150),
  },
  computed: {},
  created() {
    this.$emit("update", this.inputArray);
    this.localFilters = this.filters.map((e) => new Filter(e));
    this.filters.forEach((e) => {
      this.filterValues[e.type] = e.initial || null;
    });
  },
  watch: {
    inputArray: {
      immediate: true,
      async handler(val, oldVal) {
        this.filterEntries(this);
      },
    },
  },
};
</script>
